import { Message } from 'element-ui';
import Select2 from '@/components/widgets/select2.vue';

function get422Msg(data) {
  // return data.message + '\n' + (data.errors ? Object.values(data.errors).join('\n') : '');
  // TODO: 框架的message错误没有i18n
  return (data.errors ? Object.values(data.errors).join('\n') : '');
}


const alarmResponse = (response) => {
  // console.error(response.status);
  if (typeof response !== 'object' || response === null) {
    return;
  }
  if (response.status === 422) {
    Message.warning({
      message: get422Msg(response.data),
    });
  } else if (response.status === 403) {
    Message.warning({
      message: '无法执行指定操作，请确认您是否具有足够的权限。',
    });
  } else if (response.status === 404) {
    Message.warning({
      message: '无法获取指定数据，请确认您的操作。',
    });
  } else {
    Message({
      message: response.data ? response.data.message || response.data : '操作有误或者服务器错误',
      type: response.status >= 500 ? 'error' : 'warning',
    });
  }
  // else if (response.status === 429) {
  //   Message.warning({
  //     message: '您的操作过于频繁，请稍后再试。',
  //   });
  // }
};

// 数采仪出厂设置（新增数采仪）中数采仪的状态
const DS_STATUS = {
  1: '入库',
  2: '出库',
  3: '维修',
  4: '停用',
};

// 工控机入库的一些状态
const MS_STATUS = {
  1: '入库',
  2: '使用',
  3: '维修',
  4: '置换',
};

function dateFormat(dateObj, fmt = 'Y-m-d H:i', empty = false) {
  const days = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
  const months = [
    '一月', '二月', '三月', '四月', '五月', '六月',
    '七月', '八月', '九月', '十月', '十一月', '十二月',
  ];

  const lz = (n) => {
    const num = n.toString();
    if (num.length === 1) {
      return `0${num}`;
    }
    return num;
  };

  let t = dateObj;
  /* eslint-disable no-mixed-operators */
  // typeof dateObj !== 'string'是为了判断万一传过来的是y-m-d h:i:s格式，会直接执行最后一个else if，格式化为日期格式
  if (dateObj === null || Number.isNaN(dateObj) && typeof dateObj !== 'string') {
    if (typeof empty === 'string') {
      return empty;
    }
    t = new Date();
  } else if (typeof dateObj === 'number') {
    t = new Date(dateObj * 1000);
  } else if (typeof dateObj === 'string') {
    if (dateObj.indexOf('+') > 0) {
      t = new Date(dateObj);
    } else {
      t = new Date(dateObj.replace(/-/g, '/'));
    }
  }
  if (!(t instanceof Date)) {
    throw new Error('被处理的只能是Date对象');
  }
  if (Number.isNaN(t.getTime())) {
    throw new Error('非法日期对象');
  }
  const date = t.getDate();
  const year = t.getFullYear();
  const hours = t.getHours();
  const day = t.getDay();
  const dayName = days[day];
  const min = t.getMinutes();
  const sec = t.getSeconds();
  const month = t.getMonth();
  const am = hours < 12 ? 'am' : 'pm';
  const ms = t.getTime() % 1000;
  let hours12 = hours % 12;
  hours12 = hours12 || 12;

  const fd = new Date(t.getFullYear(), 0, 1);
  const dayOfYear = Math.round((t - fd) / 8.64e7);
  const weekNum = Math.ceil((((t - fd) / 8.64e7) + fd.getDay() - 1) / 7);

  const a = {
    d: lz(date),
    D: dayName.substr(0, 3),
    l: dayName,
    w: day,
    j: date,
    z: dayOfYear,
    W: weekNum,
    M: months[month].substr(0, 3),
    F: months[month],
    Y: year,
    a: am,
    A: am.toUpperCase(),
    y: year.toString().substr(2, 2),
    c: t.toISOString(),
    m: lz(month + 1),
    U: Math.round(t / 1000),
    g: hours12,
    G: lz(hours12),
    h: hours,
    H: lz(hours),
    i: lz(min),
    s: lz(sec),
    e: ms,
  };

  const v = [];
  Object.keys(a).forEach((k) => {
    v.push(`(\\\\)?${k}`);
  });

  return fmt.replace(new RegExp(v.join('|'), 'g'), (k) => {
    if (a[k]) {
      return a[k];
    }
    return k.replace('\\', '');
  });
}

export default {
  /* eslint-disable no-param-reassign */
  install(Vue) {
    Vue.filter(
      'dateFormat',
      (dateObj, fmt = 'Y-m-d H:i', empty = false) => dateFormat(dateObj, fmt, empty),
    );
    Vue.component('Select2', Select2);

    Vue.mixin({
      methods: {
        autoDownloadBlobFile(blob, filename) {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            const anchor = window.document.createElement('a');
            anchor.href = window.URL.createObjectURL(blob);
            anchor.download = filename;
            // anchor.click();
            this.emulateDocumentClick(anchor);
          }
        },
        emulateDocumentClick(target = null) {
          (target || window.document).dispatchEvent(new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true,
          }));
        },
      },
    });

    Vue.prototype.$sys = {
      dateFormat,
      alarmResponse,
      DS_STATUS,
      MS_STATUS,
    };
  },
};
